/**
 * Web / Electron entry point.
 *
 * Uses AppRegistry to mount the React Native app via react-native-web,
 * exactly mirroring the native index.ts entry point.
 */
import 'react-native-url-polyfill/auto';
import { Buffer } from 'buffer';
import { AppRegistry } from 'react-native';

// Polyfill Buffer for packages that expect it globally
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}

// Suppress the browser's default focus ring on every RN-Web TextInput.
//
// Mobile RN has no focus glow on iOS/Android — the cursor + container border
// are the focus affordance — and Chrome/Safari's default ring leaks outside
// our rounded pill / search containers, looks broken on dark surfaces, and
// contradicts the design system. We already inject equivalent rules in
// `mobile/web/index.html`, but Expo SDK 55's Metro web bundler ignores that
// file in SPA mode (it expects `public/index.html` instead) and serves an
// auto-generated template, so the styles only reach Electron/webpack today.
// Injecting at runtime here guarantees the rules apply in every bundler
// path (Expo Metro web AND webpack-dev-server AND the Electron renderer)
// from a single source of truth, before any TextInput has a chance to mount.
//
// Scoped to <input> / <textarea> / <select> / [contenteditable] so buttons,
// links, and other focusable elements keep their accessibility outlines.
if (typeof document !== 'undefined' && !document.getElementById('eleplan-input-focus-reset')) {
  const style = document.createElement('style');
  style.id = 'eleplan-input-focus-reset';
  style.textContent = `
    input, textarea, select, [contenteditable], [contenteditable="true"] {
      outline: none !important;
      -webkit-tap-highlight-color: transparent;
    }
    input:focus, input:focus-visible,
    textarea:focus, textarea:focus-visible,
    select:focus, select:focus-visible,
    [contenteditable]:focus, [contenteditable]:focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }
  `;
  // Append to <head> so the rule is in the cascade before the first paint.
  // Falls back to documentElement if <head> hasn't parsed yet (rare in SPA).
  (document.head || document.documentElement).appendChild(style);
}

const appName = 'mobile';

// Isolate studio frames before importing App or initializing persisted state.
const studioPreview = require('../src/screenBuilder/preview/bootstrap.web').prepareStudioPreview();
const RootComponent = studioPreview
  ? require('../src/screenBuilder/preview/PreviewHost.web').default
  : require('../App').default;
AppRegistry.registerComponent(appName, () => RootComponent);

// Mount on the #root element injected by index.html
const rootTag = document.getElementById('root');
if (rootTag) {
  AppRegistry.runApplication(appName, {
    initialProps: {},
    rootTag,
  });
}

// Remove loading splash after React's first render
// (called from App.tsx via useEffect on web platform)
export function hideSplash() {
  if (typeof window !== 'undefined' && typeof window.__hideSplash === 'function') {
    window.__hideSplash();
  }
}
